import React from 'react';

import { isMobileMedia } from 'bento-ordering/utils/media';
import MenuContainer from 'bento-ordering/menus/containers/MenuContainer';
import GroupOrderJoinManager from 'bento-ordering/group_ordering/containers/GroupOrderJoinManager';

const GroupOrderJoinContainer = () => {
  if (isMobileMedia()) {
    return <GroupOrderJoinManager />;
  }
  return <MenuContainer shouldOpenModal />;
};

export default GroupOrderJoinContainer;
